import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import LandingPage from "@/pages/LandingPage";
import EventDetailPage from "@/pages/EventDetailPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AuraMobilPage from "@/pages/AuraMobilPage";
import ManagerApp from "@/manager/ManagerApp";
import OaiqRouteTracker from "@/components/OaiqRouteTracker";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <OaiqRouteTracker />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/eventos/:id" element={<EventDetailPage />} />
            <Route path="/eventos-externos" element={<AuraMobilPage />} />
            <Route path="/aura-mobil" element={<Navigate to="/eventos-externos" replace />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/manager/*" element={<ManagerApp />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              color: "#2A2421",
              border: "1px solid #eae0df",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
